import script from "./parIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./parIndex.vue?vue&type=script&setup=true&lang=js"

import "./parIndex.vue?vue&type=style&index=0&id=139fb979&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-139fb979"]])

export default __exports__